
	import TermsAndConditionsText from "@/components/Text/TermsAndConditionsText.vue";
	import CloudMDTermsAndConditionsText from "@/components/Text/CloudMDTermsAndConditionsText.vue";
	import HeaderBarPrivacy from "@/views/patient_user/profile/components/PrivacyHeaderBar.vue";
	import DeviceInfo from "@/lib/DeviceInfo";

	export default {
		name: "TermsAndConditionsPage",
		components: {HeaderBarPrivacy, TermsAndConditionsText, CloudMDTermsAndConditionsText},
		methods: {
			isCloudMD: () =>
			{
				return DeviceInfo.isCloudMd;
			},
		},
	};
